import { Link } from '@tanstack/react-router'

export function Footer() {
  const footerLinks = [
    { href: '/legal', label: 'Legal' },
    {
      href: '/pdf/complaint-handling-policy.pdf',
      external: true,
      label: 'Complaints',
    },
    {
      href: '/pdf/financial-hardship-policy.pdf',
      external: true,
      label: 'Financial Hardship',
    },
    { href: '/faqs', label: 'FAQs' },
    { href: '/outages', label: 'Outages' },
  ]
  return (
    <footer className="bg-primary py-4 text-center text-sm">
      <div className="flex flex-row items-center justify-between breakpoint-container">
        <ul className="flex flex-row items-center shrink text-white flex-wrap">
          {footerLinks.map((link, index) => (
            <li
              className="after:content-['|'] after:px-2 after:text-white last:after:content-none whitespace-nowrap"
              key={index}
            >
              <Link
                to={link.href}
                // if extenal link pop to new tab
                {...(link.external && {
                  target: '_blank',
                  rel: 'noopener noreferrer',
                })}
                className="!no-underline hover:!underline"
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
        <p className="text-white">
          Superloop Ltd, Level 25, 150 Lonsdale St, Melbourne VIC 3000
        </p>
      </div>
    </footer>
  )
}

export default Footer
